import { BottomSheetIllustrationContent } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

interface DocumentSubmissionRejectedBottomSheetContentProps {
  title?: ReactNode;
  description?: ReactNode;
}

export function DocumentSubmissionRejectedBottomSheetContent(
  props: DocumentSubmissionRejectedBottomSheetContentProps
) {
  const { title = "Your document was rejected", description } = props;

  return (
    <BottomSheetIllustrationContent
      illustrationType="document-rejected"
      title={title}
      description={description}
    />
  );
}
